import { Box, alpha } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

// IDK How to do this
// eslint-disable-next-line react/display-name
const Explanation = React.forwardRef(
    (
        { children, arrowLeft, arrowLeftTransform, arrowRight, arrowRightTransform },
        ref
    ) => {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                    width: '100%',
                    p: 1,
                    height: '108px',
                    gap: 2,
                    borderRadius: 1,
                    backgroundColor: (theme) => alpha(theme.palette.tertiary.main, 0.5),
                }}
                ref={ref}
            >
                {arrowLeft && (
                    <Box
                        component="img"
                        src="turn-right-arrow.svg"
                        sx={{
                            transform: arrowLeftTransform || 'rotate(90deg)',
                            width: '80px',
                        }}
                    />
                )}
                <Box sx={{ flex: 1, textAlign: 'center' }}>{children}</Box>
                {arrowRight && (
                    <Box
                        component="img"
                        src="turn-right-arrow.svg"
                        sx={{
                            transform: arrowRightTransform || 'none',
                            width: '80px',
                        }}
                    />
                )}
            </Box>
        );
    }
);

Explanation.propTypes = {
    children: PropTypes.node,
    arrowLeft: PropTypes.bool,
    arrowLeftTransform: PropTypes.string,
    arrowRight: PropTypes.bool,
    arrowRightTransform: PropTypes.string,
};

export default Explanation;
